export const OVERHEADS_FILTER_KEY_SEARCH = 'searchString';
export const OVERHEADS_FILTER_KEY_PERIOD = 'period';
export const OVERHEADS_FILTER_KEY_PROJECT = 'project';
export const OVERHEADS_FILTER_KEY_CLIENT = 'client';
export const OVERHEADS_FILTER_KEY_TYPE = 'type';
export const OVERHEADS_FILTER_KEY_STATUS = 'status';

export const OVERHEADS_TABLE_FILTER_KEYS = [
  OVERHEADS_FILTER_KEY_SEARCH,
  OVERHEADS_FILTER_KEY_PERIOD,
  OVERHEADS_FILTER_KEY_PROJECT,
  OVERHEADS_FILTER_KEY_CLIENT,
  OVERHEADS_FILTER_KEY_TYPE,
  OVERHEADS_FILTER_KEY_STATUS,
];

export const OVERHEADS_TABLE_FILTERS_STORAGE_KEY = 'overheads-table-filters';

export const OVERHEADS_SEARCH_FILTER_MIN_CHARACTERS = 2;
